/* eslint-disable no-eval */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import data from './data';
export default {
  mixins: [data],
  methods: {
    build_show_field: function build_show_field() {
      var _that = this;
      var dataGridColumns = [];
      if (_that.comModelProps.showRownumbers) {
        // _that.dataGridColumns.push(_that.index_column())
        dataGridColumns.push(_that.index_column(1));
      }
      if (this.comModelProps.showCheckbox) {
        _that.showCheckbox = true;
        // _that.dataGridColumns.push(this.checkbox_colimn())
        dataGridColumns.push(_that.checkbox_colimn(1));
      }

      var modelsortFields = [];
      _that.modelShowFields.forEach(function (item, index) {
        var colItem = {};
        colItem.title = item.description;
        if (_that.dbType === 'db') {
          colItem.key = item.name.toLowerCase();
        } else {
          colItem.key = item.name;
        }
        if (item.isDic === '1') {
          colItem.key = colItem.key + 'Name';
        }

        _that.build_field_attach_props(item.attachProps, colItem, item, _that.comModelProps);
        // _that.dataGridColumns.push(colItem)
        if (item.isDisplay === '1') {
          colItem.show = true;
          dataGridColumns.push(colItem);
        } else {
          colItem.show = false;
        }
        // 是否多列筛选
        colItem.isColumnFiltering = item.isColumnFiltering;
        _that.column.push(colItem);
        // 排序字段
        if (item.sortMode) {
          modelsortFields.push(item);
        }
      });

      if (this.showOper && this.hasRowOper) {
        var operObj = {
          title: '操作',
          slot: 'action',
          align: 'center'
        };
        if (this.comModelProps.isFixed) {
          operObj.fixed = 'right';
        }
        if (this.is_real_num(this.comModelProps.operColumnWidth)) {
          operObj.width = this.comModelProps.operColumnWidth;
          this.usedWidth += parseInt(this.comModelProps.operColumnWidth);
        }
        dataGridColumns.push(operObj);
      }

      _that.dataGridColumns = dataGridColumns;
      _that.cal_show_field_wdith(_that.dataGridColumns);
      // 修复列表重置-排序失效的问题
      _that.orderKey = [];
      _that.orderType = [];
      modelsortFields.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      }).forEach(function (item, index) {
        if (_that.dbType === 'db') {
          _that.orderKey.push(item.name.toLowerCase());
        } else {
          _that.orderKey.push(item.name);
        }
        _that.orderType.push(item.sortMode);
      });
    },
    build_field_attach_props: function build_field_attach_props(attachProps, colItem, field, comModelProps) {
      // eslint-disable-next-line no-eval
      // let props = eval('(' + attachProps + ')')
      if (!attachProps) {
        return;
      }
      var props = JSON.parse(attachProps);
      if (props.width) {
        colItem.swidth = props.width;
      }
      if (props.minWidth && this.is_real_num(props.minWidth)) {
        colItem.minWidth = parseInt(props.minWidth);
      }
      // 设置ellipsis属性
      colItem.ellipsis = this.comModelProps.ellipsis;
      // 设置列表鼠标提示
      if (props.useTitle) {
        colItem.tooltip = props.useTitle;
      }
      // 设置列对齐方式
      if (props.align) {
        colItem.align = props.align;
      }

      if (comModelProps.allowAdjustColWidth) {
        colItem.resizable = true;
      }
      // 过滤
      if (props.isScreen) {
        colItem.filterMultiple = props.isMuti;
        colItem.filters = eval('(' + props.filterConfig + ')');
        colItem.filterRemote = function (value, row) {
          if (row.indexOf('Name') > -1) {
            row = row.substring(0, row.indexOf('Name'));
          }
          this.filterFields[row] = value;
          this.query_grid_data(1);
        };
      }
      /*
      colItem.filters = [{ label: '开启', value: '11111111' }, { label: '关闭', value: '2222222' }]
      colItem.filterMultiple = false
      colItem.filterRemote = function (value, row) {
          console.log(value)
          console.log(row)
      } */
      // 排序处理
      if (field.sortMode) {
        colItem.sortable = 'custom';
        colItem.sortType = field.sortMode;
      }

      if (props.slot) {
        colItem.slot = field.name.toLowerCase();
        this.slotColumn.push(colItem);
        return;
      }

      // 判断是否超链接
      if (props.hasLink) {
        var _that2 = this;
        colItem.render = function (h, params) {
          var ellipsis = '0';
          if (params.column.tooltip) {
            ellipsis = '2';
          } else if (params.column.ellipsis) {
            ellipsis = '1';
          }
          return _that2.render_hyperlink(params.row[params.column.key], params.column._width, ellipsis, props, h, params.row);
        };
      }

      var _that = this;
      if (props.render) {
        // 如果有渲染函数
        colItem.render = function (h, params) {
          var fn = null;
          eval('fn = ' + props.render);
          return fn(h, params, _that);
        };
      }
    },
    on_sort_change: function on_sort_change(_ref) {
      var column = _ref.column,
          key = _ref.key,
          order = _ref.order;

      if (order === 'normal') {
        var index = -1;
        this.dataGridColumns.some(function (item, i) {
          if (item.key === key) {
            index = i;
            return true;
          }
        });
        ~index && this.$refs.sdtable.handleSort(index, 'asc');
        return;
      }
      //处理字典
      var _key = key.replace(/(.*)Name/, '$1');
      var idx = this.array_index(this.orderKey, _key);
      if (idx > -1) {
        this.orderKey.unshift(this.orderKey.splice(idx, 1)[0]);

        this.orderType.splice(idx, 1, order);
        this.orderType.unshift(this.orderType.splice(idx, 1)[0]);
        // 从新加载列表数据
        this.query_grid_data();
      }
    },
    on_row_dblclick: function on_row_dblclick(row, index) {
      // if(this.component) {
      // this.component = null
      // } else {
      // this.component = 'iframeTemp'
      // }
      // this.modal3 = true
      var clickUrl = this.comModelProps.clickUrl;
      if (clickUrl) {
        // clickUrl += "&loginId={{:=user.loginId}}&ajbh={{:=req.ajbh}}"
        clickUrl = this.template(clickUrl, { row: row, user: this.$store.getters.sessionUser, req: this.$route.query });
        window.open(clickUrl);
      }
    },
    cal_show_field_wdith: function cal_show_field_wdith(col) {
      var _that = this;
      var wid = _that.dataGridWidth - _that.usedWidth;
      col.forEach(function (item, index) {
        if (item.swidth) {
          var width = _that.cal_col_width(wid, item.swidth);
          //if (width > 0) {
          _that.$set(item, 'width', width);
          //}
        }
      });
    },
    index_column: function index_column(flag) {
      var indexWidth = 70;
      if (flag && 1 === flag) {
        this.usedWidth += indexWidth;
      }

      return {
        title: '序号',
        type: 'index',
        width: indexWidth,
        align: 'center'
      };
    },
    checkbox_colimn: function checkbox_colimn(flag) {
      var checkboxWidth = 60;
      if (flag && 1 === flag) {
        this.usedWidth += checkboxWidth;
      }
      return {
        type: 'selection',
        width: checkboxWidth,
        align: 'center'
      };
    },
    render_hyperlink: function render_hyperlink(text, columnWidth, ellipsis, props, h, row) {
      // 渲染超链接 ellipsis 0:自动换行 1:不换行无tip提示 2:不换行tip提示
      // let maxNum = Math.floor(columnWidth / 14) - 3
      var content = text;
      // if (ellipsis !== '0' && content.length > maxNum) {
      // content = text.slice(0, maxNum) + '...' // 进行数字截取
      // }
      var _target = '_blank';
      if (props.linkOpenMode === '4') {
        _target = '_self';
      }
      var linkUrl = props.linkUrl;
      if (linkUrl) {
        linkUrl = this.template(linkUrl, { row: row, user: this.$store.getters.sessionUser, req: this.$route.query });
      }

      var aObj = { innerHTML: '<a href=\'' + linkUrl + '\' target=\'' + _target + '\'>' + content + '</a>' };
      if (ellipsis === '2') {
        return h('div', [h('Tooltip', {
          props: {
            theme: 'light',
            transfer: true
          }
        }, [h('span', { domProps: aObj }), h('span', {
          slot: 'content',
          style: {
            whiteSpace: 'normal'
          }
        }, text)])]);
      } else {
        return h('div', [h('span', { domProps: aObj })]);
      }
    },
    multi_col_change: function multi_col_change(index) {
      this.column[index].show = !this.column[index].show;
      var _that = this;
      var dataGridColumns = [];
      if (_that.comModelProps.showRownumbers) {
        // _that.dataGridColumns.push(_that.index_column())
        dataGridColumns.push(_that.index_column());
      }
      if (this.comModelProps.showCheckbox) {
        // _that.dataGridColumns.push(this.checkbox_colimn())
        dataGridColumns.push(_that.checkbox_colimn());
      }
      var wid = _that.dataGridWidth - _that.usedWidth;
      _that.column.forEach(function (item) {
        if (item.show) {
          if (item.swidth) {
            var width = _that.cal_col_width(wid, item.swidth);
            _that.$set(item, 'width', width);
          }

          dataGridColumns.push(item);
        }
      });
      if (this.showOper && this.hasRowOper) {
        var operObj = {
          title: '操作',
          slot: 'action',
          align: 'center'
        };
        if (this.comModelProps.isFixed) {
          operObj.fixed = 'right';
        }
        if (this.is_real_num(this.comModelProps.operColumnWidth)) {
          operObj.width = this.comModelProps.operColumnWidth;
        }
        dataGridColumns.push(operObj);
        // this.usedWidth += this.comModelProps.operColumnWidth
        //alert(this.usedWidth)
      }
      _that.dataGridColumns = dataGridColumns;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/showFields.js
// module id = 24
// module chunks = 0